import { SgdsMasthead } from '@govtechsg/sgds-masthead-react'

const MastheadAnnouncement = () => {
    return (
        <>
            <SgdsMasthead fluid></SgdsMasthead>
            <div className="om-api-updates">
                <div className="gradient-banner"></div>
                <div className="om-api-text">
                    <b style={{"color":"#F5333F"}}>IMPORTANT:</b><b> Search API</b> now requires token-based authentication. <a href="/apidocs/register">Register your token to ensure uninterrupted service.</a>
                </div>
            </div>
        </>
    );
}


export default MastheadAnnouncement;